module.exports = __webpack_public_path__ + "static/21-bc356ecafb57e23dada3118bdb9080f0.jpg";